import { TYPE } from '@/lib/ui/typography'

/**
 * Platform header height classes used across the layout, header, and fallback skeleton.
 * Update all values together when changing the header height.
 */
export const HEADER_HEIGHT_CLASS = {
  height: 'h-[3.05rem]',
  triggerButton: 'size-8',
} as const

/**
 * Canonical class string for the page title rendered on the LEFT of the app
 * header (e.g. "Home", "Emails", "Brand", "Audience"). Every page must
 * render its title with this exact styling so that titles are visually
 * identical across all signed-in routes regardless of whether they go
 * through `<PlatformHeader />`, the `DefaultPageTitle` fallback, a
 * breadcrumb, or a custom header injector.
 *
 * This is `TYPE.title` from the product type scale
 * (`docs/architecture/product-typography.md`). Update the role there.
 */
export const PAGE_TITLE_CLASSES = TYPE.title
